"use client";

import { Avatar, Button, Modal } from "@arco-design/web-react";
import "./index.scss";
import EvokeSkuAction from "../EvokeSkuAction";
import { TProductInfo } from "@/typings";
import { EventConfig } from "@/hooks/useAddShowcase";
import { IconCheckCircle } from "@arco-design/web-react/icon";

interface ShowcaseSampleGuildModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
  product: TProductInfo;
  eventConfig?: EventConfig;
}

const ShowcaseSampleGuideModal: React.FC<ShowcaseSampleGuildModalProps> = (
  props
) => {
  const { visible, onCancel, onOk, product, eventConfig } = props;

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      autoFocus={false}
      focusLock={true}
      className={"yf-show-case-sample-guide-modal"}
      footer={null}
    >
      <Avatar className={"yf-avatar"} size={64}>
        <IconCheckCircle className="yf-check-icon" />
      </Avatar>
      <p className="yf-guild-tip">
        This item has been successfully added to the tiktok showcase,you can
        request sample now.
      </p>
      <div className="yf-show-case-sample-guide-actions">
        <Button className={"yf-cancel-btn"} size={"large"} onClick={onCancel}>
          cancel
        </Button>
        <EvokeSkuAction product={product} eventConfig={eventConfig}>
          <Button
            className={"yf-sample-btn"}
            size={"large"}
            status={"success"}
            onClick={onOk}
          >
            Request Sample
          </Button>
        </EvokeSkuAction>
      </div>
    </Modal>
  );
};

export default ShowcaseSampleGuideModal;
